export default [
	{
		path: 'servicos/pregao-online',
		component: () => import('@/pages/Servicos/PregaoOnline/Pages/Index'),
		name: 'PregaoOnline',
		meta: {
			path: '/servicos/pregao-online',
			pai: 'Início',
			title: 'Admin - Pregão Online',
			navigation: [{
				pagina: 'Home',
				class: 'ace-icon fa fa-home home-icon',
				active: false,
				url: '/'
			},
			{
				pagina: 'Pregão Online',
				class: '',
				active: true,
				url: false
			}],
			noCache: true
		}
	}
]